import { render, staticRenderFns } from "./HotelsList.vue?vue&type=template&id=b5df666c&scoped=true&"
import script from "./HotelsList.vue?vue&type=script&lang=js&"
export * from "./HotelsList.vue?vue&type=script&lang=js&"
import style0 from "./HotelsList.vue?vue&type=style&index=0&id=b5df666c&lang=scss&scoped=true&"
import style1 from "./HotelsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5df666c",
  null
  
)

export default component.exports